import React from 'react'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import DiscoModal from 'components/ui/disco-modal'
import Icon from 'components/ui/icon'
import styles from './index.module.css'

type Props = {
  onCancel: (...args: Array<any>) => any
  onConfirm: (...args: Array<any>) => any
  playlistName: string
}

const WatermarkingNotFinished = ({
  onCancel,
  onConfirm,
  playlistName,
}: Props): React.ReactNode => {
  return (
    <DiscoModal
      style={{
        overlay: {
          zIndex: 1000,
          backgroundColor: '#02120cb3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      onRequestClose={onCancel}
      className="flc"
      isOpen
      handle
    >
      <div className={styles.watermarkingNotFinished}>
        <h2 className={styles.watermarkingNotFinishedTitle}>
          <Icon type="warning" />
          Warning: playlist not watermarked
        </h2>

        <p className={styles.watermarkingNotFinishedDescription}>
          A playlist included in this email, ‘{playlistName}’, has been marked
          for watermarking but watermarking has not yet completed. You can view
          the progress of watermarking here. If it doesn’t complete soon,
          contact us.
        </p>
        <DialogFooter
          onClose={onCancel}
          primary={<Button caption="Send anyway" onClick={onConfirm} />}
        />
      </div>
    </DiscoModal>
  )
}

export default WatermarkingNotFinished
